export const formatContentSelectValue = values => {
  if (values && values.map) {
    return values.map(item => ({
      value: (item || {})._id || (item || {}).value,
      label: (item || {}).nome || (item || {}).label || (item || {}).descricao || (item || {}).principioAtivo
    }))
  } else {
    return []
  }
}

export default formatContentSelectValue



// WEBPACK FOOTER //
// ./src/utils/formatContentSelectValue.js